import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { Route, BrowserRouter, Switch } from "react-router-dom";

import configureStore from './store'
import Home from "./Home";
import Service from "./Service";
import Quote from "./Quote";
import About from "./About";
import Contact from "./Contact";
import NavbarComp from "./NavbarComp";
import Admin from "./Admin";
import Footer from "./Footer";

import './App.css';

const store = configureStore()

const Frontend = () => {
  return (
    <div>
      <NavbarComp />
      <Switch className="main-page">
        <Route exact path="/" component={Home} />
        <Route exact path="/service" component={Service} />
        <Route exact path="/quote" component={Quote} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/about" component={About} />
      </Switch>
      <Footer />
    </div>
  );
}

const Backend = () => {
  return (
    <div>
      <Switch>
        <Route exact path='/admin' component={Admin}/>
        <Route path='/admin/:projectkey' component={Admin}/>
      </Switch>
    </div>
  );
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route path="/admin" component={Backend} />
            <Route path="/" component={Frontend} />
          </Switch>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js